import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";

import  AddSubCategoryLayer  from "../components/AddSubCategoryLayer";

export const AddSubCategoryPage = () => {
  return (
    <MasterLayout>
      {/* <AddSubCategoryLayer/> */}
      <AddSubCategoryLayer />
    </MasterLayout>
  );
};
